import type { CountryCode } from "libphonenumber-js";
import type React from "react";

import { type ElementProps, Input, type InputProps } from "@mantine/core";
import { usePhoneInput } from "react-international-phone";

import classes from "./InternationalMdnInput.module.css";

interface MdnInputProps extends InputProps, ElementProps<"input", keyof InputProps> {
    onInput: ElementProps<"input", keyof InputProps>["onInput"];
    value: string;
    defaultCountry?: CountryCode;
}

export function InternationalMdnInput({
    defaultCountry = "US",
    value,
    onInput,
    ...restProps
}: Omit<MdnInputProps, "className">) {
    const phoneInput = usePhoneInput({
        defaultCountry: defaultCountry.toLowerCase(),
        value,
        onChange: ({ phone }) => {
            onInput?.({
                currentTarget: { value: phone },
            } as React.InputEvent<HTMLInputElement>);
        },
    });

    return (
        <Input
            value={phoneInput.inputValue}
            onChange={phoneInput.handlePhoneValueChange}
            ref={phoneInput.inputRef}
            type="tel"
            classNames={{ input: classes.mdn }}
            data-testid="international-mdn-input"
            {...restProps}
        />
    );
}
